import { put } from 'redux-saga/effects';
import { create } from 'apisauce';
import { setContent } from '../actions/configAction';
import { urls } from '../../constants';

export function* getContent() {
    const response = yield create({
        baseURL: urls.CONTENT_URL,
    }).get();
    
    if (response.ok) {
        yield put(setContent(response.data));
    }
}
